import {observer} from 'mobx-react-lite';
import React from 'react';

import {Header, StyledListSection} from './styles';

export interface Props {
  className?: string;
  header: string;
  title?: string;
}

export function ListSectionComponent({
  header,
  className,
  title,
}: Props): React.ReactElement {
  return (
    <StyledListSection className={className} title={title} aria-hidden>
      <Header>{header}</Header>
    </StyledListSection>
  );
}

export default observer(ListSectionComponent);
